import * as XLSX from 'xlsx';
import { DayAgoPipe } from '../../shared/day-ago.pipe';
import { Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { UserDataService } from '../../features/user-data.service';

@Component({
  selector: 'app-critical',
  templateUrl: './critical.component.html',
  styleUrls: ['./critical.component.css']
})
export class CriticalComponent implements OnInit, OnChanges {
  status="";
  users:any;
  userskeys:any;
  detail=new Subject();//the detail of a key data will be send to patent detail
  usersForRender:any; //cut the inventors part render purposes
  error="";
  token="";
  record:string="";
  userSubs!:Subscription;
  userWithToken:any;
  searchText:any;
  today=Date.now();
  oneDay = 24*60*60*1000;
  paintRows:any;
  lastStatus:any;
  visible=false;
  users1:any;
  users1Reverse:any;
  constructor(private userData:UserDataService, private user:AuthService, private route:Router) {

   }

   ngOnInit(): void {
    this.token=this.user.token;
    this.userData.fetchUsers(this.token).subscribe(
      (res: any) => {
       this.visible=true;
       if (!res) {
         this.record="Buluş Bulunamadı"
       } else {

       //console.log(res);
       this.userWithToken=res;
       this.users = Object.keys(res).map((key) =>
       {   return res[key] });
       this.users1 = Object.keys(res).map((key) =>
       {   res[key][0].status=res[key][0].status.slice(-1)[0];

          return res[key] });

       this.userskeys= Object.keys(res).map((key) =>
       { return (key) });
       /*this.paintRows=Object.keys(res).map((key) =>
       { return res[key][0].status.slice(-1)[0].date });*/
       this.paintRows=Object.keys(res).map((key) =>
       { return res[key][0].status.date });
      /* this.lastStatus=Object.keys(res).map((key) =>
       { return res[key][0].status.slice(-1)[0] });*/
       /*this.users.status={};
       this.users.status=Object.keys(res).map((key) =>
       { return res[key][0].status.slice(-1)[0] });*/
       //console.log(this.users1,this.userskeys,this.paintRows);


       this.record=""
     }},err=>this.error=(err.statusText)
   );
    }
    ngOnChanges(): void {
      this.token=this.user.token;
      this.userData.fetchUsers(this.token).subscribe(
        (res: any) => {
         this.visible=true;
         if (!res) {
           this.record="Buluş Bulunamadı"
         } else {

         //console.log(res);
         this.userWithToken=res;
         this.users = Object.keys(res).map((key) =>
         {   return res[key] });
         this.users1 = Object.keys(res).map((key) =>
         {   res[key][0].status=res[key][0].status.slice(-1)[0];
            return res[key] });
            
         this.userskeys= Object.keys(res).map((key) =>
         { return (key) });
         /*this.paintRows=Object.keys(res).map((key) =>
         { return res[key][0].status.slice(-1)[0].date });*/
         this.paintRows=Object.keys(res).map((key) =>
         { return res[key][0].status.date });
        /* this.lastStatus=Object.keys(res).map((key) =>
         { return res[key][0].status.slice(-1)[0] });*/
         /*this.users.status={};
         this.users.status=Object.keys(res).map((key) =>
         { return res[key][0].status.slice(-1)[0] });*/
         //console.log(this.users1,this.userskeys,this.paintRows,this.lastStatus);


         this.record=""
       }},err=>this.error=(err.statusText)
     );
      }

/*
  fetchUsers() {

    this.userData.fetchUsers(this.token).subscribe(
       (res: any) => {
        this.visible=true;
        if (!res) {
          this.record="Buluş Bulunamadı"
        } else {

        console.log(res);
        this.userWithToken=res;
        this.users = Object.keys(res).map((key) =>
        {   return res[key] });
        this.users1 = Object.keys(res).map((key) =>
        {   res[key][0].status=res[key][0].status.slice(-1)[0];
           return res[key] });

        this.userskeys= Object.keys(res).map((key) =>
        { return (key) });

        this.paintRows=Object.keys(res).map((key) =>
        { return res[key][0].status.date });

        console.log(this.users1,this.userskeys,this.paintRows,this.lastStatus);


        this.record=""
      }},err=>this.error=(err.statusText)
    );
    } */
    removeInvention(i:number) {
      //console.log(this.userskeys[i]);
      /* this.http.delete('https://sisecam-a8421-default-rtdb.firebaseio.com/patents/'+ this.users.key[i] +'.json?auth='+this.token).subscribe(res=>{console.log(res)},err=> this.error=(err.statusText));*/
      this.userData.removeInvention(this.userskeys[i]);
      this.redirectTo('patentList');
    }
    inventionDetails(i:number, docNo:string){

      this.route.navigate(['patentList/',docNo]);
      //console.log(this.detail);
      this.userData.getKey(this.userskeys[i]);

     }
    redirectTo(uri:string){
      this.route.navigateByUrl('/', {skipLocationChange: true}).then(()=>
      this.route.navigate([uri]));
   }
   fileName= 'BuluşKayıtları.xlsx';

   exportexcel(): void
 {
   /* pass here the table id */
   let element = document.getElementById('excel-table');
   const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

   /* generate workbook and add the worksheet */
   const wb: XLSX.WorkBook = XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(wb, ws, 'Buluş Bilgileri');

   /* save to file */
   XLSX.writeFile(wb, this.fileName);

 }
}
